import { ItemType }      from 'Models/UI/ItemType';
import { TS_AddonMisc } from '../TravelSeller/Models/TS_AddonMisc';

export class AddonMisc extends TS_AddonMisc {
    type = ItemType.MISC;
}